export const initialNodesData = [
  {
    id: "ONB_TYC",
    line: 1,
    data: {
      id: "ONB_TYC",
      label: "T&C",
      image: "/diagram/tc.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_SSN",
    line: 1,
    data: {
      id: "ONB_SSN",
      label: "SSN",
      image: "/diagram/id.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_PERSONAL_INFORMATION",
    line: 1,
    data: {
      id: "ONB_PERSONAL_INFORMATION",
      label: "Personal Info",
      image: "/diagram/profile.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_INITIAL_BALANCE",
    line: 1,
    data: {
      id: "ONB_INITIAL_BALANCE",
      label: "Initial Balance",
      image: "/diagram/accounts.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },

  {
    id: "ONB_EMAIL",
    line: 1,
    data: {
      id: "ONB_EMAIL",
      label: "Email",
      image: "/diagram/email.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_SMS",
    line: 1,
    data: {
      id: "ONB_SMS",
      label: "SMS",
      image: "/diagram/sms.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_DOCUMENT_ID",
    line: 1,
    data: {
      id: "ONB_DOCUMENT_ID",
      label: "ID Validation",
      image: "/diagram/id.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_PRODUCT_SELECTION",
    line: 1,
    data: {
      id: "ONB_PRODUCT_SELECTION",
      label: "Product Selections",
      image: "/diagram/productselection.png",
      width: "120px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_COMPANY_DATA",
    line: 1,
    data: {
      id: "ONB_COMPANY_DATA",
      label: "Company Data",
      image: "/diagram/companydata.png",
      width: "120px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_UPLOAD_DOCUMENTS",
    line: 1,
    data: {
      id: "ONB_UPLOAD_DOCUMENTS",
      label: "Upload Documents",
      image: "/diagram/uploaddocuments.png",
      width: "120px",
      right: true,
      left: true,
    },
    type: "customNode",
  },

  {
    id: "ONB_BIOMETRICS",
    line: 1,
    data: {
      id: "ONB_BIOMETRICS",
      label: "Biometric",
      image: "/diagram/biometric.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_CREDENTIALS",
    line: 1,
    data: {
      id: "ONB_CREDENTIALS",
      label: "Credentials",
      image: "/diagram/credentials.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_POSTONBOARDING",
    line: 1,
    data: {
      id: "ONB_POSTONBOARDING",
      label: "User Preferences",
      image: "/diagram/postonboarding.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_VIDEORECORDING",
    line: 1,
    data: {
      id: "ONB_VIDEORECORDING",
      label: "Video Recording",
      image: "/diagram/videorecording.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_PRODUCT_SELECTION",
    line: 1,
    data: {
      id: "ONB_PRODUCT_SELECTION",
      label: "Product selection",
      image: "/diagram/product_selection.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_COMPANY_DATA",
    line: 1,
    data: {
      id: "ONB_COMPANY_DATA",
      label: "Company data",
      image: "/diagram/company_data.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_UPLOAD_DOCUMENTS",
    line: 1,
    data: {
      id: "ONB_UPLOAD_DOCUMENTS",
      label: "Attach documents",
      image: "/diagram/attach_documents.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "ONB_CHECKOUT",
    line: 1,
    data: {
      id: "ONB_CHECKOUT",
      label: "Checkout",
      image: "/diagram/checkout.png",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "SOLUTIONS",
    line: 2,
    data: {
      id: "SOLUTIONS",
      label: "Wallet",
      image: "/veritran.png",
      width: "1020px",
      top: true,
      bottom: true,
    },
    type: "customNode",
  },
  {
    id: "DIGITAL_ONBOARDING",
    urlCondition: "hasdigitalonboarding",
    line: 0,
    data: {
      label: "Digital Onboarding",
      image: "/diagram/profile.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "MARKET_REVIEW",
    urlCondition: "hasmarketreview",
    line: 0,
    data: {
      label: "Market Review",
      image: "/diagram/investing.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "GLOBAL_TRANSFER",
    urlCondition: "hasglobaltransfer",
    line: 0,
    data: {
      label: "Global Transfer",
      image: "/diagram/global-transfers.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "ACCOUNTS_MANAGER",
    urlCondition: "hasaccountsmanager",
    line: 0,
    data: {
      label: "Accounts Manager",
      image: "/diagram/accounts.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "SECURE_LINKS",
    urlCondition: "hassecurelinks",
    line: 0,
    data: {
      label: "Secure Links",
      image: "/diagram/tc.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "GLOBAL_TRANSFERS",
    urlCondition: "hasGlobalTransfers",
    line: 0,
    data: {
      label: "Global Transfers",
      image: "/diagram/global-transfers.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "BIOMETRIC_PAYMENTS",
    urlCondition: "hasbiometricpayments",
    line: 0,
    data: {
      id: "BIOMETRIC_PAYMENTS",
      label: "Biometric Payments",
      image: "/diagram/biometric.svg",
      width: "130px",
      right: true,
      left: true,
    },
    type: "customNode",
  },
  {
    id: "GOALS",
    urlCondition: "hasGoals",
    line: 0,
    data: {
      label: "Goals",
      image: "/diagram/goals.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "VERITOKS",
    urlCondition: "hasVeritoks",
    line: 0,
    data: {
      label: "Veritoks",
      image: "/diagram/veritoks.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "SEND_MONEY",
    urlCondition: "hasRequestMoney",
    line: 0,
    data: {
      label: "SendMoney",
      image: "/diagram/send-money.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "REQUEST_MONEY",
    urlCondition: "hasRequestMoney",
    line: 0,
    data: {
      label: "Request Money",
      image: "/diagram/phone.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "QR_PAYMENTS",
    urlCondition: "hasQRPayments",
    line: 0,
    data: {
      label: "QR Payments",
      image: "/diagram/qr-payments.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DYNAMIC_CVV",
    urlCondition: "hasDynamicCVV",
    line: 0,
    data: {
      label: "Dynamic CVV",
      image: "/diagram/dynamic-cvv.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DATA_ENRICHMENT",
    urlCondition: "hasDataEnrichment",
    line: 0,
    data: {
      label: "Data Enrichment",
      image: "/diagram/data-enrichment.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TAP_TO_PHONE",
    urlCondition: "hasTapToPhone",
    line: 0,
    data: {
      label: "Tap & Phone",
      image: "/diagram/tap-phone.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "LOYALTY",
    urlCondition: "hasLoyalty",
    line: 0,
    data: {
      label: "Loyalty",
      image: "/diagram/loyalty.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAYEES",
    urlCondition: "hasPayees",
    line: 0,
    data: {
      label: "Bill Payments",
      image: "/diagram/request-money.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "RECHARGE",
    urlCondition: "hasRecharge",
    line: 0,
    data: {
      label: "Recharge",
      image: "/diagram/recharge.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DYNAMIC_CONTENT",
    urlCondition: "hasDynamicContent",
    line: 0,
    data: {
      label: "Dynamic Content",
      image: "/diagram/dynamic-content.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INVESTMENTS",
    line: 0,
    urlCondition: "hasInvestments",
    data: {
      label: "Investments",
      image: "/diagram/investments.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "LOCAL_CURRENCY",
    line: 0,
    urlCondition: "haslocalcurrency",
    data: {
      label: "Local Currency",
      image: "/diagram/foreigncurrency.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DEBIT_CARD",
    line: 0,
    urlCondition: "hasdebitcard",
    data: {
      label: "Debit Card",
      image: "/diagram/debitcard.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAYMENTS",
    line: 0,
    urlCondition: "hastransfersandpayments",
    data: {
      label: "Payments",
      image: "/diagram/payments.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "FOREIGN_CURRENCY",
    line: 0,
    urlCondition: "hasforeigncurrency",
    data: {
      label: "Foreign Currency",
      image: "/diagram/foreigncurrency.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CHARGING",
    line: 0,
    urlCondition: "haschargingstores",
    data: {
      label: "Charging Stores",
      image: "/diagram/investments.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "SUPPLIERS",
    line: 0,
    urlCondition: "hassupplierspayment",
    data: {
      label: "Suppliers",
      image: "/diagram/proveedores.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CREDIT_CARD",
    line: 0,
    urlCondition: "hascreditcard",
    data: {
      label: "Corporate Cards",
      image: "/diagram/creditcard.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "STADIUM_ACCESS",
    line: 0,
    urlCondition: "hasstadiumaccess",
    data: {
      label: "Stadium Access",
      image: "/diagram/stadium.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TICKET_MANAGER",
    line: 0,
    urlCondition: "hasticketmanager",
    data: {
      label: "Ticket Manager",
      image: "/diagram/tickets.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "QR_ACCESS",
    line: 0,
    urlCondition: "qraccess",
    data: {
      label: "Ticket Manager",
      image: "/diagram/qraccess.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INSURANCE",
    line: 0,
    urlCondition: "hasinsurance",
    data: {
      label: "Insurance",
      image: "/diagram/insurance.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "LOANS",
    line: 0,
    urlCondition: "hasloans",
    data: {
      label: "Loans",
      image: "/diagram/loans.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CORPORATE_BANKING",
    line: 0,
    urlCondition: "hascorporatebanking",
    data: {
      label: "Web Banking",
      image: "/diagram/corporatebanking.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "AGREEMENT_ACCOUNT",
    line: 0,
    urlCondition: "hasagreementaccount",
    data: {
      label: "Agreement",
      image: "/diagram/agreementaccount.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAYROLL",
    line: 0,
    urlCondition: "haspayroll",
    data: {
      label: "Payroll",
      image: "/diagram/payroll.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CHECKS",
    line: 0,
    urlCondition: "hascheckbook",
    data: {
      label: "Checks",
      image: "/diagram/cheques.png",
      width: "160px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "ATM",
    line: 0,
    urlCondition: "hasAtm",
    data: {
      label: "ATMs",
      image: "/diagram/dynamic-cvv.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "ACCOUNTS",
    line: 0,
    urlCondition: "hasaccounts",
    data: {
      label: "Accounts",
      image: "/diagram/accounts.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAYMENTS",
    line: 0,
    urlCondition: "haspayments",
    data: {
      label: "Payments",
      image: "/diagram/payments.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CARDS",
    line: 0,
    urlCondition: "hascards",
    data: {
      label: "Cards",
      image: "/diagram/cards.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DEPOSIT_CHECKS",
    line: 0,
    urlCondition: "hasdepositcheck",
    data: {
      label: "Deposit Check",
      image: "/diagram/depositcheck.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PROFILE",
    line: 0,
    urlCondition: "hasprofile",
    data: {
      label: "Profile",
      image: "/diagram/profile.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INSURANCE",
    line: 0,
    urlCondition: "hasacademic_insurance",
    data: {
      label: "Academic Insurance",
      image: "/diagram/profile.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INVESTING",
    line: 0,
    urlCondition: "hasinvesting",
    data: {
      label: "Investing",
      image: "/diagram/investing.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAY_BILLS",
    line: 0,
    urlCondition: "haspaybills",
    data: {
      label: "Pay Bills",
      image: "/diagram/paybills.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CNEX",
    line: 0,
    urlCondition: "hascnex",
    data: {
      label: "CNEx",
      image: "/diagram/cnex.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DOMESTIC_TRANSFERS",
    line: 0,
    urlCondition: "hasdomestictransfer",
    data: {
      label: "Domestic Transfer",
      image: "/diagram/domestictransfer.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "WIRED_TRANSFER",
    line: 0,
    urlCondition: "haswiredtransfer",
    data: {
      label: "Wired Transfer",
      image: "/diagram/wiredtransfer.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TOP_UP",
    line: 0,
    urlCondition: "hasTopUp",
    data: {
      label: "Top Up",
      image: "/diagram/recharge.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "LOCAL_CURRENCY",
    line: 0,
    urlCondition: "hasLocalCurrency",
    data: {
      label: "Local currency account",
      image: "/diagram/local_currency_account.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DEBIT_CARD",
    line: 0,
    urlCondition: "hasDebitCard",
    data: {
      label: "Debit card",
      image: "/diagram/debit_card.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TRANSFERS_AND_PAYMENTS",
    line: 0,
    urlCondition: "hasTransfersAndPayments",
    data: {
      label: "Digital transfers and payments",
      image: "/diagram/digital_transfer_payments.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "FOREIGN_CURRENCY",
    line: 0,
    urlCondition: "hasForeignCurrency",
    data: {
      label: "Foreign currency account",
      image: "/diagram/foreign_currency_account.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CHARGING_STORES",
    line: 0,
    urlCondition: "hasChargingStores",
    data: {
      label: "Charging in stores",
      image: "/diagram/charging_in_stores.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "SUPPLIERS_PAYMENT",
    line: 0,
    urlCondition: "hasSuppliersPayment",
    data: {
      label: "Payment to suppliers",
      image: "/diagram/payment_to_suppliers.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "COLLECTIONS",
    line: 0,
    urlCondition: "hasCollections",
    data: {
      label: "Collections",
      image: "/diagram/collection.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INVESTMENTS_BUSINESS",
    line: 0,
    urlCondition: "hasInvestmentsBusiness",
    data: {
      label: "Investments Business",
      image: "/diagram/investment.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CREDIT_CARD",
    line: 0,
    urlCondition: "hasCreditCard",
    data: {
      label: "Credit card",
      image: "/diagram/credit_card.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "INSURANCE",
    line: 0,
    urlCondition: "hasInsurance",
    data: {
      label: "Insurance",
      image: "/diagram/insurance.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "LOANS",
    line: 0,
    urlCondition: "hasLoans",
    data: {
      label: "Loans",
      image: "/diagram/request-money.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CORPORATE_BANKING",
    line: 0,
    urlCondition: "hasCorporateBanking",
    data: {
      label: "Corporate banking",
      image: "/diagram/corporate_banking.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "AGREEMENT_ACCOUNT",
    line: 0,
    urlCondition: "hasAgreementAccount",
    data: {
      label: "Agreement on account",
      image: "/diagram/agreement_on_account.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PAYROLL",
    line: 0,
    urlCondition: "hasPayroll",
    data: {
      label: "Payroll",
      image: "/diagram/payroll.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CHECKBOOK",
    line: 0,
    urlCondition: "hasCheckbook",
    data: {
      label: "Checkbook",
      image: "/diagram/checkbook.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TAP_TO_CONFIRM",
    line: 0,
    urlCondition: "hastaptoconfirm",
    data: {
      label: "Tap to Confirm",
      image: "/diagram/taptoconfirm.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TAP_TO_P2P",
    line: 0,
    urlCondition: "hastaptop2p",
    data: {
      label: "Tap to P2P",
      image: "/diagram/taptop2p.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CARD_TO_CARD",
    line: 0,
    urlCondition: "hascardtocard",
    data: {
      label: "Card to Card",
      image: "/diagram/taptop2p.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "PUSH_PROVISIONING",
    line: 0,
    urlCondition: "haspushprovisioning",
    data: {
      label: "Push Provisioning",
      image: "/diagram/pushprovisioning.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "WALLET_EXTENSION",
    line: 0,
    urlCondition: "haswalletextension",
    data: {
      label: "Push Provisioning",
      image: "/diagram/walletextension.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "DIGITAL_CARD_DISPLAY",
    line: 0,
    urlCondition: "hasdigitalcarddisplay",
    data: {
      label: "Digital Card Display",
      image: "/diagram/cards.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "SPLIT_PAYMENTS",
    line: 0,
    urlCondition: "hassplitpayment",
    data: {
      label: "Split Payments",
      image: "/diagram/splitpayments.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "OFFLINE_PAYMENTS",
    line: 0,
    urlCondition: "hasofflinepayments",
    data: {
      label: "Offline Payments",
      image: "/diagram/offlinepayments.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CLICK_TO_PAY",
    line: 0,
    urlCondition: "hasclicktopay",
    data: {
      label: "Click To Pay",
      image: "/diagram/ctp.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TAP_TO_EVERYTHING",
    line: 0,
    urlCondition: "hastaptoeverything",
    data: {
      label: "Tap To Everything",
      image: "/diagram/taptoeverything.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TOKENIZATION_EFFORTLESS",
    line: 0,
    urlCondition: "hastokenizationeffortless",
    data: {
      label: "Tokenization Effortless",
      image: "/diagram/pushprovisioning.png",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "CAMPUS_VIRTUAL",
    line: 0,
    urlCondition: "hascampusvirtual",
    data: {
      label: "Campus Virtual",
      image: "/diagram/campusvirtual.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "BOOKSTORE",
    line: 0,
    urlCondition: "hasbookstore",
    data: {
      label: "Bookstore",
      image: "/diagram/bookstore.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "TRANSPORT_PASS",
    line: 0,
    urlCondition: "hastransportpass",
    data: {
      label: "Transport Pass",
      image: "/diagram/transportpass.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "NOTIFICATIONS",
    line: 0,
    urlCondition: "hasnotifications",
    data: {
      label: "Notifications",
      image: "/diagram/notifications.svg",
      width: "130px",
      top: true,
    },
    type: "customNode",
  },
  {
    id: "MODULES",
    line: 3,
    data: {
      id: "MODULES",
      label: "Modules",
      image: "/diagram/wallet.svg",
      width: "1020px",
      top: true,
      bottom: true,
      items: [],
    },
    type: "iconGridNode",
  },
];

export const initialEdgesData = [];

export const line3Conditions = [
  { param: "hasglobaltransfers", code: "GLOBAL_TRANSFERS" },
  { param: "hasgoals", code: "GOALS" },
  { param: "hasbiometricpayments", code: "BIOMETRIC_PAYMENTS" },
  { param: "hasveritoks", code: "VERITOKS" },
  { param: "hassendmoney", code: "SEND_MONEY" },
  { param: "hasrequestmoney", code: "REQUEST_MONEY" },
  { param: "hasqrpayments", code: "QR_PAYMENTS" },
  { param: "hasdynamiccvv", code: "DYNAMIC_CVV" },
  { param: "hasdataenrichment", code: "DATA_ENRICHMENT" },
  { param: "hastaptophone", code: "TAP_TO_PHONE" },
  { param: "hastaptoconfirm", code: "TAP_TO_CONFIRM" },
  { param: "hastaptop2p", code: "TAP_TO_P2P" },
  { param: "hascardtocard", code: "CARD_TO_CARD" },
  { param: "hastaptop", code: "TAP_TO_PHONE" },
  { param: "haspushprovisioning", code: "PUSH_PROVISIONING" },
  { param: "haswalletextension", code: "WALLET_EXTENSION" },
  { param: "hasdigitalcarddisplay", code: "DIGITAL_CARD_DISPLAY" },
  { param: "hasclicktopay", code: "CLICK_TO_PAY" },
  { param: "hastaptoeverything", code: "TAP_TO_EVERYTHING" },
  { param: "hastokenizationeffortless", code: "TOKENIZATION_EFFORTLESS" },
  { param: "hasloyalty", code: "LOYALTY" },
  { param: "haspayees", code: "PAYEES" },
  { param: "hasrecharge", code: "RECHARGE" },
  { param: "hasdynamiccontent", code: "DYNAMIC_CONTENT" },
  { param: "hasinvestments", code: "INVESTMENTS" },
  { param: "haslocalcurrency", code: "LOCAL_CURRENCY" },
  { param: "hasdebitcard", code: "DEBIT_CARD" },
  { param: "hastransfersandpayments", code: "PAYMENTS" },
  { param: "hasforeigncurrency", code: "FOREIGN_CURRENCY" },
  { param: "haschargingstores", code: "CHARGING_STORE" },
  { param: "hassupplierspayment", code: "SUPPLIERS" },
  { param: "hascreditcard", code: "CREDIT_CARD" },
  { param: "hasinsurance", code: "INSURANCE" },
  { param: "hasloans", code: "LOANS" },
  { param: "hascorporatebanking", code: "CORPORATE_BANKING" },
  { param: "hasagreementaccount", code: "AGREEMENT_ACCOUNT" },
  { param: "haspayroll", code: "PAYROLL" },
  { param: "hascheckbook", code: "CHECKS" },
  { param: "hasatm", code: "ATM" },
  { param: "hastopup", code: "TOP_UP" },
  { param: "haslocalcurrency", code: "LOCAL_CURRENCY" },
  { param: "hasdebitcard", code: "DEBIT_CARD" },
  { param: "hastransfersandpayments", code: "TRANSFERS_AND_PAYMENTS" },
  { param: "hasforeigncurrency", code: "FOREIGN_CURRENCY" },
  { param: "haschargingstores", code: "CHARGING_STORES" },
  { param: "hassupplierspayment", code: "SUPPLIERS_PAYMENT" },
  { param: "hascollections", code: "COLLECTIONS" },
  { param: "hasinvestmentsbusiness", code: "INVESTMENTS_BUSINESS" },
  { param: "hascreditcard", code: "CREDIT_CARD" },
  { param: "hasinsurance", code: "INSURANCE" },
  { param: "hasloans", code: "LOANS" },
  { param: "hascorporatebanking", code: "CORPORATE_BANKING" },
  { param: "hasagreementaccount", code: "AGREEMENT_ACCOUNT" },
  { param: "haspayroll", code: "PAYROLL" },
  { param: "hascheckbook", code: "CHECKBOOK" },
  { param: "hasaccounts", code: "ACCOUNTS" },
  { param: "haspayments", code: "PAYMENTS"},
  { param: "hascards", code: "CARDS"},
  { param: "hasdepositcheck", code: "DEPOSIT_CHECKS"},
  { param: "hasprofile", code: "PROFILE" },
  { param: "hasacademic_insurance", code: "INSURANCE" },
  { param: "hasticketmanager", code: "TICKET_MANAGER" },
  { param: "hasqraccess", code: "QR_ACCESS" },
  { param: "hasstadiumaccess", code: "STADIUM_ACCESS" },
  { param: "hasinvesting", code: "INVESTING" },
  { param: "haspaybills", code: "PAY_BILLS"},
  { param: "hasbillpayments", code: "PAY_BILLS"},
  { param: "hascnex", code: "CNEX"},
  { param: "hasdomestictransfer", code: "DOMESTIC_TRANSFERS" },
  { param: "haswiredtransfer", code: "WIRED_TRANSFER"},
  { param: "hassplitpayment", code: "SPLIT_PAYMENTS" },
  { param: "hasofflinepayments", code: "OFFLINE_PAYMENTS" },
  { param: "hascampusvirtual", code: "CAMPUS_VIRTUAL" },
  { param: "hasbookstore", code: "BOOKSTORE" },
  { param: "hastransportpass", code: "TRANSPORT_PASS" },
  { param: "hasnotifications", code: "NOTIFICATIONS" },

];
